import React from "react";
import Navbar from "../Common/Navbar.jsx";
import "../Blog/Blog.css";
import BlogPost from "./BlogPost.jsx";
import Footer from '../Common/Footer.jsx';

const Blog = () => {

  return (
    <>
      <div className="blog_container">
        <div className="blog_bgs">
          <Navbar />
          <div className="blog_head_container">
            <h1>Blog &amp; Insights</h1>
            <p className="blog_head_subtitle">
              Explore expert tips, news, and strategies on tax consulting, bookkeeping, and financial growth.
            </p>
          </div>
        </div>
      </div>

      <div className="blog">
        <div className="blog_bg py-5">
          <div className="blog_head_container py-5 d-flex justify-content-center">
            <div className="blog_head_item col-12 col-md-10 col-lg-6" data-aos="fade-up">
              {/* <h6
                className="text-center"
                style={{ color: "#4A6EC9", textTransform: "uppercase" }}
              >
                blog
              </h6> */}
              <h2 className="text-center" >Latest Blog Post</h2>
              <p className="text-center blog_para pt-3 ">
                Explore expert insights and tips on tax consulting and business services.
                Stay informed and make smart financial decisions with our regular updates!
              </p>
            </div>
          </div>
          <div className="container-fluid px-0">
            <BlogPost />
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default Blog;
